import * as actionTypes from '../actions';

const initialState = {
    adminPage: false,
    adminLoggedIn: false,
    adminConfigurationSaved: false,
    adminLoginErrorState: {
        hasError: false,
        errorMessage: ""
    },
};

let getProducts = (state, data) => {
    let newState = Object.assign({}, state);
    newState.productsData = data;
    return newState;
};

const adminReducer = (state = initialState, action) => {
    let newState = null;
    
    if (action.type === actionTypes.SET_ADMIN_PAGE) {
        return {
            ...state,
            adminPage: true
        }
    }
    
    if (action.type === actionTypes.ADMIN_SUCCESSFULY_LOGGED_IN) {
        return {
            ...state,
            adminLoggedIn: true
        }
    }

    if (action.type === actionTypes.ADMIN_SUCCESSFULY_LOGGED_OUT) {
        return {
            ...state,
            adminLoggedIn: false
        }
    }

    if (action.type === actionTypes.ADMIN_PAGE_SET_SAVED) {
        return {
            ...state,
            adminConfigurationSaved: action.value
        }
    }

    if (action.type === actionTypes.SET_ADMIN_LOGIN_ERROR) {
        newState = Object.assign({}, state);
        newState.adminLoginErrorState = {
            hasError: true,
            errorMessage: action.errorMessage
        };
        return newState;
    }

    if (action.type === actionTypes.CLEAR_ADMIN_LOGIN_ERROR) {
        newState = Object.assign({}, state);
        newState.adminLoginErrorState = {
            hasError: false,
            errorMessage: ""
        };
        return newState;
    }

    return state;
};

export default adminReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/admin.js